import React, { useEffect, useCallback } from 'react'

import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux';

// Hooks

import InsertSpouseAndRepresentativePepForRevision from '../../../../../hooks//InsertSpouseAndRepresentativePepForRevision';

// Components

import SectionHeading from '../../../../UI/SectionHeading/SectionHeading';
import Alert from '../../../../UI/Alert/Alert';
import RadioInput from '../../../../UI/FormInput/RadioInput';
import Button from '../../../../UI/Button/Button';
import BankReferenceFields from '../BankReferenceFields';
import Loader from '../../../../UI/Loader/Loader';

export default function BankReferences({formik, formStep, setFormStep}) {
    const {
        insertSpouseRepresentativePepForRevisionIsLoading,
        insertSpouseRepresentativePepForRevisionError,
        insertSpouseRepresentativePepForRevision,
        handleInsertSpouseRepresentativePepForRevision
    } = InsertSpouseAndRepresentativePepForRevision();

    const { state } = useLocation();

    const navigate = useNavigate();
    const dispatch = useDispatch();


    // Check if client is pep to insert for review

    useEffect(() => {
        if (formik.values?.pep?.pregunta1?.nombreCargo !== '0' || formik.values?.pep?.hasAssociate === 'si') {
            handleInsertarClienteEnListaParaRevision(formik.values);
        }
        
        if (!['1', '2', '6'].includes(formik.values?.cliente?.tipoCliente)) {
            formik.setFieldValue('hasBankReference', 'no')
        }
    }, [])


    // Handle Insert Client On List For Review

    const handleInsertarClienteEnListaParaRevision = useCallback((values) => {
        const peopOnlist = {
            pep: values?.pep?.pregunta1?.nombreCargo !== '0',
            asociate: formik.values?.pep?.hasAssociate === 'si'
        };

        if ((peopOnlist?.pep || peopOnlist?.asociate) && state?.userPartialData?.lists?.pep?.is_blocked !== 0) {
            handleInsertSpouseRepresentativePepForRevision(values, 'pep', false, false, peopOnlist, state);
        }
    }, []);

    useEffect(() => {
        if (insertSpouseRepresentativePepForRevision?.success) {
            navigate('/solicitud', { state: { userPartialData: { is_blocked: true } }});
        }
    }, [insertSpouseRepresentativePepForRevision, navigate]);

    return (
    <>

        {(insertSpouseRepresentativePepForRevisionIsLoading || insertSpouseRepresentativePepForRevisionError) &&
        <Loader 
            message={'Registrando cliente PEP para revisión...'}
            error={insertSpouseRepresentativePepForRevisionError}
            action={() => handleInsertarClienteEnListaParaRevision(formik.values)}
        />}


        {(!insertSpouseRepresentativePepForRevisionIsLoading && !insertSpouseRepresentativePepForRevisionError) &&
        <>
            <SectionHeading text={'Conozcámonos un poco más'} />
            {['1', '2', '6'].includes(formik.values?.cliente?.tipoCliente) &&
            <>
                <Alert text={'Para completar una solicitud de apertura de cuenta es obligatoria una referencia bancaria. En caso de no poseer relación con ninguna entidad financiera, completa una referencia personal.'} />

                <RadioInput
                    formik={formik}
                    fieldName={'hasBankReference'}
                    label={'¿Posee referencia bancaria?'}
                    options={[{label: 'Sí', value: 'si'},{label: 'No', value: 'no'},]}
                    isGroup={true}
                    isRequired={true}
                />

                {formik.values?.hasBankReference === 'si' &&
                    <BankReferenceFields formik={formik} />
                }
            </>}

            {!['1', '2', '6'].includes(formik.values?.cliente?.tipoCliente) &&
                <Alert text={'Puedes continuar'} />
            }

            <div className='form-actions'>

                <Button
                    action={() => dispatch(setFormStep(formStep - 1))}
                    label={'Regresa'}
                    secondaryStyle={true}
                />

                <Button
                    type="submit"
                    action={formik.handleSubmit}
                    label={'Continua'}
                />

            </div>
        </>}
    </>
  )
}
